import * as React from 'react'
import { useState, useEffect, useRef } from 'react'
import * as Yup from 'yup'
import { Field, Form, Formik } from 'formik'
import toast from 'react-hot-toast'
import { useSelector } from 'react-redux'
import config from '../../../config'
import axiosInstant from '../../../api'
import { useUser } from '../../../hooks/useUser'
import { postRetrieveSubscriptionUrl } from '../../../api/endpoints'

export default function Subscription(props) {
  const { user, brand } = useUser()

  useEffect(async () => {

    // if(user.subscription && user.subscription.customer) {
    //   let payload = { customer: user.subscription.customer }
    //   let response = await axiosInstant.post(postRetrieveSubscriptionUrl(brand[0].id), payload)
    //   window.location.replace(response.data.url)
    // }
    
  }, [])

  return (
    <>
      {/* { !user.subscription ? (
        <p>
          <b>You have a free account.</b> To upgrade purchase a subscription from <a href="https://desireco.com" target="_blank">https://desireco.com</a>.
        </p>
      ) : (
        <p>Redirecting you to your subscription management area...</p>
      ) } */}
      <p>TDC Studio Subscription.</p>
    </>
  )
}
